import { FormEventHandler, MutableRefObject } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LogSearchConditions } from '../../../api/model';
import DatePicker from '../../atoms/DatePicker';
import SlideToggle from '../../modules/SlideToggle';

interface Props {
  openSearchConditions: boolean;
  defaultConditions: LogSearchConditions;
  conditionsRef: MutableRefObject<LogSearchConditions>;
  setConditionsAndSearch: (value: LogSearchConditions) => void;
}

// Companies
function LogSearch({ openSearchConditions, defaultConditions, conditionsRef, setConditionsAndSearch }: Props) {
  const { t } = useTranslation();

  // フォーム情報
  const { control, handleSubmit } = useForm<LogSearchConditions>({
    defaultValues: { ...defaultConditions },
  });

  // フォーム送信
  const onSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    void handleSubmit((data) => {
      const next: LogSearchConditions = {
        ...conditionsRef.current,
        log_at_from: data.log_at_from,
        log_at_to: data.log_at_to,
      };
      // 検索実行など
      setConditionsAndSearch(next);
    })();
  };

  return (
    <SlideToggle open={openSearchConditions}>
      <form id="production-search-conditions" onSubmit={onSubmit}>
        <div className="wfr scondition trigfr mb50 fropen">
          <div className="grid3 labip4">
            <div>
              <label htmlFor="log_at_from">{t('日付From')}</label>
              <DatePicker id="log_at_from" name="log_at_from" isDisabled={false} control={control} displayMark />
            </div>
            <div>
              <label htmlFor="log_at_to">{t('日付End')}</label>
              <DatePicker id="log_at_to" name="log_at_to" isDisabled={false} control={control} displayMark />
            </div>
          </div>
          <div className="mb0 bfall1 conf-req-btn1fr">
            <div className="btnfr-right1">
              <div className="controlfr">
                <span>
                  <input type="submit" value={t('検索').toString()} className="searchbtn" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </SlideToggle>
  );
}

export { LogSearch };
